import { fabric } from 'fabric';
import DEFINE from '../define';
import ToolBase from '../basic';
import ruler30 from '../../../assets/art/math_tool/ruler30.svg';
import ruler100_1 from '../../../assets/art/math_tool/0-25_ruler100.svg';
import ruler100_2 from '../../../assets/art/math_tool/26-50_ruler100.svg';
import ruler100_3 from '../../../assets/art/math_tool/51-75_ruler100.svg';
import ruler100_4 from '../../../assets/art/math_tool/76-100_ruler100.svg';
import { focusStore } from '../../store/nowFocusStore';
import CustomControls from '../custom_controls/custom_controls';

export default class Ruler extends ToolBase {

    name = DEFINE.TOOLS.RULER;

    originPosition = new fabric.Point(600, 550);
    scale = 0.5;

    targetTag = "";
    originPointer = null;
    dragObjOrigX = null;
    rulerOrigX = null;
    clipOrigX = null;

    // 直尺
    ruler30 = null;
    ruler100 = null;
    ruler100_1 = null;
    ruler100_2 = null;
    ruler100_3 = null;
    ruler100_4 = null;
    dragArea = null;
    dragObj = null;
    btnSwitch = null;
    ruler = null;

    //遮罩寬度
    clipWidth = 1300;
    //拖曳物件大小
    dragObjSize = 15;


    customControl = new CustomControls();

    constructor(parent) {
        super(parent);
    }

    create() {
        super.create();

        const self = this;

        this.originPosition.x = focusStore.mainBookPage.pagePercentPoint.x * this.parent.canvas.width;
        this.originPosition.y = focusStore.mainBookPage.pagePercentPoint.y * this.parent.canvas.height;

        // 限制只能生成一個
        this.canvas.getObjects().forEach(object => {
            if (object && (object.tag || "").includes(DEFINE.TAG.RULER)) {
                self.canvas.remove(object);
            }
        });

        //生成30公分直尺
        fabric.loadSVGFromURL(ruler30, (objects, options) => {
            self.ruler30 = new fabric.util.groupSVGElements(objects, options);

            self.ruler30.set({
                tag: DEFINE.TAG.RULER_30 + new Date().getTime(),
                left: self.originPosition.x ,
                top: self.originPosition.y,
                angle: 0,
                scaleX: self.scale,
                scaleY: self.scale,
                originX: "left",
                originY: "center",
                visible: false,
                lockScalingFlip: true,
            });

            //生成100公分直尺以及其他部件和群組
            //因100公分尺長度過長導致刷新遮罩時會延遲，需分成四段並透過開關visible來增加效能
            fabric.loadSVGFromURL(ruler100_1, (objects, options) => {
                self.ruler100_1 = new fabric.util.groupSVGElements(objects, options);
                self.ruler100_1.set({
                    tag: DEFINE.TAG.RULER_100_1 + new Date().getTime(),
                    left: self.originPosition.x + 100,
                    top: self.originPosition.y,
                    originX: "left",
                    originY: "center",
                });
                fabric.loadSVGFromURL(ruler100_2, (objects, options) => {
                    self.ruler100_2 = new fabric.util.groupSVGElements(objects, options);
                    self.ruler100_2.set({
                        tag: DEFINE.TAG.RULER_100_2 + new Date().getTime(),
                        left: self.ruler100_1.left + self.ruler100_1.width,
                        top: self.originPosition.y,
                        originX: "left",
                        originY: "center",
                        // visible: false
                    });
                    fabric.loadSVGFromURL(ruler100_3, (objects, options) => {
                        self.ruler100_3 = new fabric.util.groupSVGElements(objects, options);
                        self.ruler100_3.set({
                            tag: DEFINE.TAG.RULER_100_3 + new Date().getTime(),
                            left: self.ruler100_2.left + self.ruler100_2.width,
                            top: self.originPosition.y,
                            originX: "left",
                            originY: "center",
                            // visible: false
                        });
                        fabric.loadSVGFromURL(ruler100_4, (objects, options) => {
                            self.ruler100_4 = new fabric.util.groupSVGElements(objects, options);
                            self.ruler100_4.set({
                                tag: DEFINE.TAG.RULER_100_4 + new Date().getTime(),
                                left: self.ruler100_3.left + self.ruler100_3.width,
                                top: self.originPosition.y,
                                originX: "left",
                                originY: "center",
                                // visible: false
                            });

                            self.ruler100 = new fabric.Group([self.ruler100_1, self.ruler100_2, self.ruler100_3, self.ruler100_4], {
                                tag: DEFINE.TAG.RULER_100 + new Date().getTime(),
                                left: self.originPosition.x,
                                top: self.originPosition.y,
                                angle: 0,
                                scaleX: self.scale,
                                scaleY: self.scale,
                                originX: "left",
                                originY: "center"
                            });
                            self.ruler100.set({
                                // 設定遮罩
                                clipPath: new fabric.Rect({
                                    width: self.clipWidth,
                                    height: self.ruler100.height,
                                    left: -(self.ruler100.width - self.clipWidth) / 2,
                                    originX: 'center',
                                    originY: 'center'
                                }),
                                lockScalingFlip: true
                            });

                            //產生拖曳區域
                            self.dragArea = new fabric.Rect({
                                tag: DEFINE.TAG.RULER_DRAG_AREA + new Date().getTime(),
                                left: self.originPosition.x,
                                top: self.originPosition.y + self.ruler100.height * self.scale / 2,
                                width: self.clipWidth / 2 - 0.5,
                                height: self.dragObjSize,
                                fill: DEFINE.COLOR.MATH_TOOL.WHITE_255_255_255,
                                originX: 'left',
                                originY: 'top'
                            });

                            //產生拖曳元件
                            self.dragObj = new fabric.Rect({
                                tag: DEFINE.TAG.RULER_DRAG_OBJ + new Date().getTime(),
                                left: self.originPosition.x,
                                top: self.originPosition.y + self.ruler100.height * self.scale / 2,
                                width: self.dragObjSize,
                                height: self.dragObjSize,
                                fill: DEFINE.COLOR.MATH_TOOL.GREEN_0_175_79,
                                originX: 'left',
                                originY: 'top',
                            });

                            //產生切換按鈕
                            self.btnSwitch = new fabric.Circle({
                                tag: DEFINE.TAG.RULER_BTN + new Date().getTime(),
                                left: self.originPosition.x + self.clipWidth / 2,
                                top: self.originPosition.y + self.ruler100.height * self.scale / 5,
                                radius: 5,
                                fill: DEFINE.COLOR.MATH_TOOL.YELLOW_255_191_0,
                                originX: 'center',
                                originY: 'center',
                            });

                            //將產生的物件群組
                            self.ruler = new fabric.Group([self.ruler30, self.ruler100, self.dragArea, self.dragObj, self.btnSwitch], {
                                tag: DEFINE.TAG.RULER + new Date().getTime(),
                                toolType: self.name,
                                selectionActive: true,
                                originX: 'left',
                                originY: 'top',
                                selectable: true,
                                perPixelTargetFind: true,
                                hasBorders: false,
                                subTargetCheck: true,    //讓子物件可以個別觸發事件
                                controls: Object.assign(this.getBasicControls(), {
                                    mtr: this.getTouchRotateControl({
                                        x: -0.5,
                                        y: 0.5,
                                        offsetX: -60,
                                        offsetY: -45,
                                        cornerSize: 32
                                    }, false),
                                    rotateNinetyIcon: this.getRotateNinetyControl({
                                        x: -0.5,
                                        y: 0.5,
                                        offsetX: -25,
                                        offsetY: -10,
                                        cornerSize: 32
                                    }),
                                    scaleIcon: this.getRulerScaleControl({
                                        x: -0.5,
                                        y: 0.5,
                                        offsetX: -60,
                                        offsetY: -10,
                                        cornerSize: 32
                                    }),
                                    deleteControl: this.getDeleteControl({
                                        x: -0.5,
                                        y: 0.5,
                                        offsetX: -25,
                                        offsetY: -45,
                                        cornerSize: 32
                                    }),
                                })
                            });
                            
                            self.ruler.left = self.originPosition.x - self.ruler30.width * self.ruler30.scaleX * 0.25;

                            self.rulerOrigX = self.ruler100.left;
                            self.clipOrigX = self.ruler100.clipPath.left;

                            
                            self.canvas.add(self.ruler);
                            self.ruler.setCoords();
                            self.enableScaleControl(self.ruler, false);
                            self.canvas.renderAll();
                        });
                    });
                });
            });
        });
    }

    recover(object) {
        let tag = object.tag;

        if (tag.includes(DEFINE.TAG.RULER)) {
            this.ruler = object;
            this.ruler["_objects"].forEach(object => {
                console.log(object);
                if (object.tag && object.tag.includes(DEFINE.TAG.RULER_BTN)) {
                    this.btnSwitch = object;
                } else if (object.tag && object.tag.includes(DEFINE.TAG.RULER_DRAG_AREA)) {
                    this.dragArea = object;
                } else if (object.tag && object.tag.includes(DEFINE.TAG.RULER_DRAG_OBJ)) {
                    this.dragObj = object;
                } else if (object.tag && object.tag.includes(DEFINE.TAG.RULER_30)) {
                    this.ruler30 = object;
                } else if (object.tag && object.tag.includes(DEFINE.TAG.RULER_100)) {
                    this.ruler100 = object;
                    this.ruler100["_objects"].forEach(object => {
                        if (object.tag && object.tag.includes(DEFINE.TAG.RULER_100_1)) {
                            this.ruler100_1 = object;
                        } else if (object.tag && object.tag.includes(DEFINE.TAG.RULER_100_2)) {
                            this.ruler100_2 = object;
                        } else if (object.tag && object.tag.includes(DEFINE.TAG.RULER_100_3)) {
                            this.ruler100_3 = object;
                        } else if (object.tag && object.tag.includes(DEFINE.TAG.RULER_100_4)) {
                            this.ruler100_4 = object;
                        }
                    });
                }
            });
        }
    }

    mouseUp(o) {
        this.parent.changeTool(null);
    }

    mouseDown(o) {
        if (o.target) {
            if (o.target.tag) {
                if (o.target.tag.includes(DEFINE.TAG.RULER)) {
                    this.ruler.set('lockMovementX', false);
                    this.ruler.set('lockMovementY', false);
                    if (o.subTargets[0] && o.subTargets[0].tag) {
                        this.targetTag = o.subTargets[0].tag;
                    } else {
                        this.targetTag = o.target.tag;
                    }

                    this.originPointer = o.pointer;
                }
            }
        }

        this.ruler.canvas._activeObject = this.ruler;

        if (this.targetTag.includes(DEFINE.TAG.RULER_DRAG_AREA)) {
            this.canvas.discardActiveObject(o.target);
            this.ruler.lockMovementX = true;
            this.ruler.lockMovementY = true;

            let newPosX = -this.ruler.width / 2 + (o.pointer.x - this.ruler.left) - this.dragObjSize / 2;
            this.setDragObjPos(newPosX);
        } else if (this.targetTag.includes(DEFINE.TAG.RULER_DRAG_OBJ)) {
            this.canvas.discardActiveObject(o.target);
            this.ruler.lockMovementX = true;
            this.ruler.lockMovementY = true;

            this.dragObjOrigX = this.dragObj.left;
        } else if (this.targetTag.includes(DEFINE.TAG.RULER_BTN)) {
            this.ruler30.set('visible', !this.ruler30.visible);
            this.ruler100.set('visible', !this.ruler30.visible);
            this.dragArea.set('visible', !this.ruler30.visible);
            this.dragObj.set('visible', !this.ruler30.visible);
        }

        this.canvas.renderAll();
    }

    mouseMove(o) {
        if (!this.targetTag.includes(DEFINE.TAG.RULER)) return;

        let offset = new fabric.Point(o.pointer.x - this.originPointer.x, o.pointer.y - this.originPointer.y);

        if (this.targetTag.includes(DEFINE.TAG.RULER_DRAG_OBJ)) {
            if (offset.x == 0) return;

            let newPosX = this.dragObjOrigX + offset.x;
            this.setDragObjPos(newPosX);
        }

        this.canvas.renderAll();
    }

    //移動拖曳物件
    setDragObjPos = function (posX) {
        //限制拖曳物件範圍
        let minX = -this.ruler.width / 2;
        let maxX = minX + this.clipWidth / 2 - this.dragObjSize;

        if (posX < minX) posX = minX;
        if (posX > maxX) posX = maxX;

        this.dragObj.set('left', posX);
        //重置實際座標位置
        this.dragObj.setCoords();

        //根據移動比例改動遮罩顯示位置
        this.setClipArea((posX - minX) / (maxX - minX));

        //此方法才能減緩dirty卡頓
        // this.canvas.requestRenderAll();
        this.canvas.renderAll();

    }

    //改變遮罩顯示位置
    setClipArea = function (ratioX) {
        //根據比例開關各段visible
        this.ruler100_1.set('visible', ratioX < 0.35);
        this.ruler100_2.set('visible', ratioX > 0.05 && ratioX < 0.65);
        this.ruler100_3.set('visible', ratioX > 0.35 && ratioX < 0.95);
        this.ruler100_4.set('visible', ratioX > 0.65);
        console.log(ratioX)
        ratioX *= (this.ruler100.width - this.clipWidth) / 2;
        this.ruler100.set('left', this.rulerOrigX - ratioX);

        this.ruler100.clipPath.set('left', this.clipOrigX + ratioX * 2);
        this.ruler100.set('dirty', true);
        // this.canvas.renderAll();

        this.ruler100.setCoords();
    }
}